<template>
  <div v-if="show" class="reward-popup-overlay" @click="closePopup">
    <img :src="getAssetsFile('activity/close20.png')" alt="" class="w-[33px] h-[33px] absolute top-30 right-10"
      @click="closePopup">
    <div class="bgsdt">
      <div class="absolute top-14 left-0 right-0 color-[#ffffff] text-[13px] text-center pl-[10px]">{{
        t('rewardPopup.title') }}</div>
      <div class="absolute top-22 left-19 color-[#8A0F03] text-[13px] flex items-center justify-center flex-col">
        <div class="relative text-center">
          <div class=" text-center">{{ t('rewardPopup.congratulations') }}</div>
          <div class="biankses">
            <div class="reward-amount" v-if="rewardAmount.reward">{{ VITE_symbol }} {{ numberFormat(rewardAmount.reward,
              { minDecimals: 2 }) }} </div>
            <div class="reward-amount" v-if="rewardAmount.rewardBound">{{ VITE_symbol }} {{
              numberFormat(rewardAmount.rewardBound, {
                minDecimals: 2
              }) }} </div>
            <div class="color-[#EC2C1B] text-center">{{ formatCountdown(countdownSeconds) }} {{
              t('rewardPopup.expiresIn') }}</div>
          </div>
          <div class="winstyle">{{ t('rewardPopup.win') }}</div>
          <div class="color-[##8A0F03] text-[13px] mt-2 text-center multi-line-text">{{ t('rewardPopup.description') }}
          </div>
        </div>

      </div>
      <div class="erisers text-[11.5px]" @click.stop="handleClaim">{{ t('rewardPopup.claimButton') }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch, onMounted, onUnmounted } from 'vue'
import { useRewardStore } from '@/stores/modules/reward'
import { numberFormat } from '@/utils/formatter'
import { useRouter } from 'vue-router'
import * as GameApi from '@/api/game'
import { useI18n } from 'vue-i18n'
import { getAssetsFile } from '@/utils/pub-use'
const { t } = useI18n()
const VITE_symbol = import.meta.env.VITE_SYMBOL
const router = useRouter()

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['close', 'abandon'])

const rewardStore = useRewardStore()

// 从store获取数据 - 使用computed确保响应式更新
const rewardAmount = computed(() => {
  // console.log('rewardAmount computed 被调用，当前值:', rewardStore.rewardAmount)
  return rewardStore.rewardAmount
})
const countdownSeconds = computed(() => {
  // console.log('countdownSeconds computed 被调用，当前值:', rewardStore.countdownSeconds)
  return rewardStore.countdownSeconds
})

let countdownTimer: NodeJS.Timeout | null = null

// 格式化倒计时显示
const formatCountdown = (seconds: number) => {
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const secs = seconds % 60

  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
}

// 处理充值领奖按钮点击
const handleClaim = () => {
  // 跳转到充值页面
  router.push('/Deposito')
  // 关闭弹窗但不跳转首页
  if (countdownTimer) {
    clearInterval(countdownTimer)
    countdownTimer = null

  }
  // emit('close')
}

// 开始倒计时
const startCountdown = () => {
  if (countdownTimer) {
    clearInterval(countdownTimer)
  }

  // console.log('开始倒计时，初始倒计时秒数:', rewardStore.countdownSeconds)

  // 如果倒计时为0或负数，不启动倒计时
  if (rewardStore.countdownSeconds <= 0) {
    console.log('倒计时为0或负数，不启动倒计时')
    return
  }

  countdownTimer = setInterval(() => {
    // console.log('倒计时进行中，当前秒数:', rewardStore.countdownSeconds)

    if (rewardStore.countdownSeconds > 0) {
      // 更新store中的倒计时
      rewardStore.updateCountdown(rewardStore.countdownSeconds - 1)
    } else {
      // 倒计时结束
      // console.log('倒计时结束，关闭弹窗')
      clearInterval(countdownTimer)
      countdownTimer = null
      closePopup()
    }
  }, 1000)
}

// 关闭弹窗（不放弃奖励）
const closePopup = () => {
  if (countdownTimer) {
    clearInterval(countdownTimer)
    countdownTimer = null
  }

  // 判断是否已经抽完奖：有奖励金额或状态为已领取/已过期
  const hasReward = (rewardAmount.value.reward && rewardAmount.value.reward > 0) ||
    (rewardAmount.value.rewardBound && rewardAmount.value.rewardBound > 0)
  const isCompleted = rewardStore.status === 1 || rewardStore.status === 2

  // 如果已经抽完奖，跳转到充值页面
  if (hasReward || isCompleted) {
    router.push('/Deposito')
  } else {
    emit('close')
  }
}

// 放弃奖励
const abandonReward = async () => {
  if (countdownTimer) {
    clearInterval(countdownTimer)
    countdownTimer = null
  }

  try {
    // 调用放弃奖励接口
    // await GameApi.giveUp()
    console.log('放弃奖励成功')
  } catch (error) {
    console.error('放弃奖励失败:', error)
  }

  // 清除store中的数据
  rewardStore.clearData()

  // 跳转到首页
  router.push('/')
  emit('abandon')
}

// 监听show变化
watch(() => props.show, (newVal) => {
  if (newVal) {
    console.log('RewardPopup 开始显示，当前localStorage数据:', localStorage.getItem('rewardData'))

    // 重新从localStorage加载数据
    rewardStore.loadFromStorage()

    console.log('RewardPopup 显示，重新加载后的store数据:', {
      rewardAmount: rewardStore.rewardAmount,
      countdownSeconds: rewardStore.countdownSeconds
    })
    console.log('RewardPopup 计算属性值:', {
      rewardAmount: rewardAmount.value,
      countdownSeconds: countdownSeconds.value
    })

    // 强制更新计算属性
    console.log('强制更新后的计算属性值:', {
      rewardAmount: rewardAmount.value,
      countdownSeconds: countdownSeconds.value
    })

    startCountdown()
  } else {
    // 弹窗关闭时停止倒计时
    if (countdownTimer) {
      clearInterval(countdownTimer)
      countdownTimer = null
    }
  }
})

onMounted(() => {
  // 从localStorage加载数据
  rewardStore.loadFromStorage()
  console.log('RewardPopup onMounted - 从localStorage加载后的数据:', {
    rewardAmount: rewardStore.rewardAmount,
    countdownSeconds: rewardStore.countdownSeconds
  })

  if (props.show) {
    startCountdown()
  }
})

onUnmounted(() => {
  if (countdownTimer) {
    clearInterval(countdownTimer)
  }
})
</script>

<style lang="scss" scoped>
.reward-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.reward-popup-container {
  position: relative;
  width: 85%;
  max-width: 350px;
}

.reward-popup-content {
  position: relative;
  width: 100%;
  height: 100%;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  cursor: pointer;
}

.reward-bg {
  position: relative;
  width: 100%;
  height: auto;
}

.reward-bg-image {
  width: 100%;
  height: auto;
  display: block;
}

.reward-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

/* 标题横幅 */
.reward-title {
  font-size: 13px;
  font-weight: bold;
  color: #fff;
  background-color: #ff4444;
  padding: 4px 12px;
  border-radius: 4px;
  margin-bottom: 8px;
  text-align: center;
}

/* 恭喜文字 */
.congratulations {
  font-size: 14px;
  font-weight: bold;
  color: #000;
  margin-bottom: 8px;
  text-align: center;
}

/* 赢得标签 */
.win-label {
  font-size: 12px;
  color: #ff6600;
  background-color: #fff;
  padding: 2px 8px;
  border-radius: 12px;
  margin-bottom: 5px;
  font-weight: bold;
  text-align: center;
}

/* 中奖金额 */
.reward-amount {
  font-size: 16px;
  font-weight: bold;
  color: #ff4444;
  margin: 10px 0;
  margin-bottom: 5px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  line-height: 1.2;
  margin-top: 20px;
  text-align: center;
  white-space: nowrap;
}

/* 倒计时 */
.countdown {
  font-size: 10px;
  color: #000;
  font-weight: bold;
  margin-bottom: 8px;
  text-align: center;
}

/* 说明文字 */
.description {
  font-size: 11px;
  color: #000;
  margin-bottom: 15px;
  line-height: 1.3;
  text-align: center;
}

/* 充值领奖按钮 */
.claim-button {
  background: linear-gradient(135deg, #ffed00, #ffcc00);
  color: #ff4444;
  font-size: 14px;
  font-weight: bold;
  padding: 12px 30px;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  min-width: 120px;
  text-align: center;
}

.claim-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.claim-button:active {
  transform: translateY(0);
}

.bgsdt {
  background: getPath('activity/456.png') no-repeat;
  background-size: 100% 100%;
  width: 80%;
  height: 350px;
  position: relative;
}

.biankses {
  border: 1px dashed #F98213;
  border-radius: 10px;
  height: 100px;
  width: 150px;
  margin-top: 15px;
}

.winstyle {
  background: #F98213;
  border-radius: 9px;
  color: #fff;
  font-size: 11px;
  text-align: center;
  width: 45px;
  position: absolute;
  top: 25px;
  left: 20%;
  transform: translateX(-50%);
}

.erisers {
  background: getPath('activity/anniu.png') no-repeat center center;
  background-size: 100% 100%;
  width: 130px;
  height: 40px;
  position: absolute;
  text-align: center;
  line-height: 40px;
  bottom: 25px;
  left: 28%;
  color: #8A0F03;
  font-weight: bold;
}

.multi-line-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 1.2;
  text-align: center;
}
</style>
